/* SWIFT — motion budget (ours: ss-motion.js)
   Finds every looping CSS animation on the page (ticker, hero zoom, logo
   marquee, feature sheen, scrolling text/images...) and:
     1. pauses it while it is off-screen, resumes when it scrolls back in;
     2. keeps it paused for visitors whose device asks for reduced motion.
   Only infinite animations are touched, so one-shot reveal/fade effects are
   never frozen. Pausing is done with the .ss-motion-paused class (custom.css). */
(function () {
  if (!('IntersectionObserver' in window) || !document.getAnimations) return;

  var CLS = 'ss-motion-paused';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var visible = new WeakMap();
  var seen = new WeakSet();

  function apply(el) {
    var pause = reduce.matches || visible.get(el) === false;
    el.classList.toggle(CLS, pause);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      visible.set(e.target, e.isIntersecting);
      apply(e.target);
    });
  }, { rootMargin: '100px 0px' });

  function scan() {
    document.getAnimations().forEach(function (a) {
      var t = a.effect && a.effect.target;
      if (!t || seen.has(t) || !a.effect.getTiming) return;
      if (a.effect.getTiming().iterations !== Infinity) return;
      seen.add(t);
      io.observe(t);
      apply(t);
    });
  }

  function start() {
    scan();
    // catch animations that start late (lazy sections, app blocks)
    setTimeout(scan, 1500);
    setTimeout(scan, 4000);
    document.addEventListener('shopify:section:load', scan);
  }

  var onChange = function () {
    document.querySelectorAll('*').forEach(function (el) { if (seen.has(el)) apply(el); });
  };
  if (reduce.addEventListener) reduce.addEventListener('change', onChange);
  else if (reduce.addListener) reduce.addListener(onChange);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
